<script setup lang="ts">
import { MultiSelect } from '@collector/shared-ui'

import { IncidentFilterSelect } from './types'
import { getIncidentFilterName } from './utils'

const incidentFiltersSelect = defineModel<IncidentFilterSelect[]>({
  default: () => [],
})

// methods
function getGridPositionClass(index: number): string {
  if (index < Math.floor(incidentFiltersSelect.value.length / 2)) {
    return `row-start-${index + 1} col-start-1`
  } else {
    return `row-start-${index - Math.floor(incidentFiltersSelect.value.length / 2) + 1} col-start-2`
  }
}

function getGridRootClass(length: number): string {
  const rows = Math.ceil(length / 2)
  return `grid-rows-${rows} grid grid-cols-2`
}
</script>

<template>
  <div
    class="flex-col gap-y-1.5 @max-[26rem]/history-filters:flex!"
    :class="getGridRootClass(incidentFiltersSelect.length)"
  >
    <MultiSelect
      v-for="(incidentFilter, index) in incidentFiltersSelect"
      :key="index"
      :class="getGridPositionClass(index)"
      :modelValue="incidentFilter.value"
      :options="incidentFilter.options"
      withClear
      :withFilter="incidentFilter.withFilter"
      :filterPredicate="incidentFilter.filterPredicate"
      :data-testid="`${getIncidentFilterName(incidentFilter).toLowerCase()}-select`"
      @update:modelValue="
        incidentFilter.value = $event === '' ? undefined : $event
      "
    >
      <span class="w-20">
        {{ getIncidentFilterName(incidentFilter) }}
      </span>
    </MultiSelect>
  </div>
</template>
